import genGuid from './guid';
import _ from 'lodash';

export default interface BaseModel<T = unknown> {
    guid: string;
    correlationGuid: string;
    ts: string;

    data?: T;
    error?: any;
    properties?: { [key: string]: any };

    isChunked?: boolean;
    chunk?: number;
    chunksLength?: number;
    isLastChunk?: boolean;
}

export function isBaseModel(obj: unknown): obj is BaseModel {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        typeof (obj as any).guid === 'string' &&
        typeof (obj as any).correlationGuid === 'string' &&
        typeof (obj as any).ts === 'string'
    );
}

export const relatedModel = (
    { correlationGuid, properties }: { correlationGuid: string; properties: { [key: string]: any } },
    data: any,
) => ({
    guid: genGuid(),
    ts: new Date().toISOString(),
    correlationGuid: correlationGuid,
    data,
    properties: _.omit(properties, 'queueHops'),
});
